/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./TableRow.vue?vue&type=template&id=647af0e7&scoped=true"
import script from "./TableRow.vue?vue&type=script&lang=js"
export * from "./TableRow.vue?vue&type=script&lang=js"
import style0 from "./TableRow.vue?vue&type=style&index=0&id=647af0e7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "647af0e7",
  null
  
)

export default component.exports